import React, { useState } from 'react';
import { Icon } from './GrowthShell';
import { PRESETS, fmtMonth, monthGrid, rangeLabel, riyadhDay, shiftMonth, spanLabel } from '../../lib/growthRange';

// The Growth OS range picker, shared by every page that reads a range:
// presets, «مخصص» (an Arabic RTL calendar on Riyadh dates) and the
// «مقارنة بالفترة السابقة» switch. The page owns the range (it lives in the URL).

const WEEKDAYS = ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'];

// «مخصص»: an Arabic, right-to-left month calendar on Riyadh dates. First tap
// sets the start, second the end; nothing after today.
function Calendar({ range, today, onApply, onCancel }) {
  const [month, setMonth] = useState(range.to.slice(0, 7));
  const [from, setFrom] = useState(range.preset === 'custom' ? range.from : null);
  const [to, setTo] = useState(range.preset === 'custom' ? range.to : null);
  const pick = (d) => {
    if (!from || (from && to)) { setFrom(d); setTo(null); return; }
    if (d < from) { setTo(from); setFrom(d); } else setTo(d);
  };
  const lo = from; const hi = to || from;
  return (
    <div className="gos-cal" role="dialog" aria-label="اختر الفترة" data-calendar="1">
      <div className="gos-cal-head">
        <button type="button" aria-label="الشهر السابق" onClick={() => setMonth(shiftMonth(month, -1))}><Icon name="back" size={15} /></button>
        <b>{fmtMonth(month)}</b>
        <button type="button" aria-label="الشهر التالي" disabled={month >= today.slice(0, 7)} onClick={() => setMonth(shiftMonth(month, 1))}><span style={{ display: 'inline-flex', transform: 'scaleX(-1)' }}><Icon name="back" size={15} /></span></button>
      </div>
      <div className="gos-cal-grid">
        {WEEKDAYS.map((w) => <span key={w} className="gos-cal-wd">{w}</span>)}
        {monthGrid(month).map((d, i) => (d ? (
          <button key={d} type="button" disabled={d > today} data-day={d}
                  className={`gos-cal-day${lo && d >= lo && d <= hi ? ' in' : ''}${d === lo || d === hi ? ' end' : ''}${d === today ? ' today' : ''}`}
                  onClick={() => pick(d)}>{Number(d.slice(8))}</button>
        ) : <span key={`x${i}`} />))}
      </div>
      <p className="gos-cal-sel">{from ? spanLabel(from, to || from) : 'اختر يوم البداية ثم يوم النهاية'}</p>
      <div className="gos-cal-actions">
        <button type="button" className="gos-btn" disabled={!from} onClick={() => onApply(from, to || from)}>تطبيق</button>
        <button type="button" className="gos-btn ghost" onClick={onCancel}>إلغاء</button>
      </div>
      <p className="gos-cal-tz">بتوقيت الرياض</p>
    </div>
  );
}

export default function RangeBar({ range, onChange, compare = true }) {
  const [open, setOpen] = useState(false);
  const today = riyadhDay();
  return (
    <div className="gos-rangebar">
      <div className="gos-range" role="group" aria-label="الفترة">
        {PRESETS.map((p) => (
          <button key={p.key} type="button" className={range.preset === p.key ? 'on' : ''} aria-pressed={range.preset === p.key}
                  data-preset={p.key} onClick={() => { setOpen(false); onChange({ ...range, preset: p.key }); }}>{p.ar}</button>
        ))}
        <button type="button" className={range.preset === 'custom' ? 'on' : ''} aria-pressed={range.preset === 'custom'} aria-expanded={open}
                data-preset="custom" onClick={() => setOpen((o) => !o)}>
          {range.preset === 'custom' ? rangeLabel(range) : 'مخصص'}
        </button>
      </div>
      {compare && <label className="gos-switch" data-compare={range.compare ? '1' : '0'}>
        <input type="checkbox" checked={range.compare} onChange={(e) => onChange({ ...range, compare: e.target.checked })} />
        <span className="gos-switch-track" aria-hidden="true"><span /></span>
        مقارنة بالفترة السابقة
      </label>}
      {open && (
        <Calendar range={range} today={today} onCancel={() => setOpen(false)}
                  onApply={(from, to) => { setOpen(false); onChange({ ...range, preset: 'custom', from, to }); }} />
      )}
    </div>
  );
}
